import { AssetsElement } from '@lib/kontent/models/Elements'

// Function to be used as a value for the `aspectRatio` prop in CSS
export const getAspectRatioImage = (image: AssetsElement): number => {
  return parseFloat((image.value[0].width / image.value[0].height).toFixed(2))
}
